import PropTypes from 'prop-types';
import {  useState } from 'react';
import axios from 'axios.js';
// material-ui
import { useTheme } from '@mui/material/styles';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

// assets
import { EditOutlined,  LogoutOutlined, KeyOutlined } from '@ant-design/icons';

//import { useNavigate } from 'react-router';
//import { useAuth } from 'contexts/AuthContext';
// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

const ProfileTab = () => {
  const theme = useTheme();
  //let navigate = useNavigate();
  const [selectedIndex] = useState(0);
//   const handleListItemClick = (event, index) => {
//     //setSelectedIndex(index);
//     if(index==1)
//     {
//         navigate('/update-password');
//     }
//     else if(index==0)
//     {
//         // redirect to user profile
//     }
//   };

  const NavigateToEditProfile=()=>{
    // navigate('/');
    window.location.href = '/edit-profile';
 }

    const NavigateToUpdatePassword=()=>{
       // navigate('/');
       window.location.href = '/update-password';
    }

    const handleLogout = async () => {
        try {

            const resp = await axios.post('/logout');
            if (resp.status === 200) {
                localStorage.clear();
                localStorage.removeItem("Address");
                localStorage.removeItem("Address");
                                localStorage.removeItem("Address");
                                localStorage.removeItem("AdminUserID");
                                localStorage.removeItem("CompanyName");
                                localStorage.removeItem("Email");
                                 localStorage.removeItem("GSTIN");
                                 localStorage.removeItem("IsNewContactsAllowed");
                                  localStorage.removeItem("Name");
                                   localStorage.removeItem("NoOfBranchLocations");
                                    localStorage.removeItem("NoOfContacts");
                                     localStorage.removeItem("NoOfDepartments");
                                      localStorage.removeItem("NoOfGroups");
                localStorage.removeItem("ValidityInMonths");
                localStorage.removeItem("domain");
                localStorage.removeItem("PlanID");
                localStorage.removeItem("baseURL");
                localStorage.removeItem("domain");
                localStorage.removeItem('email');
                localStorage.removeItem('name');
                localStorage.removeItem('tenant');

                //updateVariableStatement();
                updateBaseURL("");

                window.location.href = '/login';
            }
        } catch (error) {
            console.log(error);
        }
    };

    const updateBaseURL = (domain) => {
        let newBaseURL;

        if (domain && domain !== "undefined" && domain !== "") {
          if (process.env.NODE_ENV === "production") {
            newBaseURL = `https://${domain}.kitcontact.in/api`;
          } else {
            newBaseURL = `http://${domain}.localhost:8084/Product/KiTReact/api`;
          }
        } else {
          newBaseURL =
            process.env.NODE_ENV === "production"
              ? "https://kitcontact.in/api"
              : "http://localhost:8084/Product/KiTReact/api";
        }

        axios.defaults.baseURL = newBaseURL;
        localStorage.setItem("baseURL", newBaseURL);
        return true;
      };

    // const handleChangePassword = () =>{
    //     // navigate to change password

    // }

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32, color: theme.palette.grey[500] } }}>
      <ListItemButton selected={selectedIndex === 0} onClick={() => NavigateToEditProfile() }>
        <ListItemIcon>
          <EditOutlined />
        </ListItemIcon>
        <ListItemText primary="Edit Profile" />
      </ListItemButton>
      <ListItemButton to='' onClick={() => NavigateToUpdatePassword()}>
        <ListItemIcon >
          <KeyOutlined/>
        </ListItemIcon>
        <ListItemText primary="Change Password" />
      </ListItemButton>

      <ListItemButton selected={selectedIndex === 2} onClick={handleLogout}>
        <ListItemIcon>
          <LogoutOutlined />
        </ListItemIcon>
        <ListItemText primary="Logout" />
      </ListItemButton>
    </List>
  );
};

ProfileTab.propTypes = {
  handleLogout: PropTypes.func
};

export default ProfileTab;
